/* ===================================================================
   Nexum · Количка-чекмедже — лепилото около Dawn
   -------------------------------------------------------------------
   Логиката на самото чекмедже е в assets/cart-drawer.js и assets/cart.js
   (Dawn, не се пипат). Тук стои само това, което Dawn няма:

     1. добавяне от карта в решетката → AJAX вместо презареждане на /cart
     2. бутоните „Добави“ в ъпсел релсата вътре в чекмеджето
     3. пресканиране на .hrail-wrap след всеки AJAX рендер (NexumRail.scan)
     4. връщане на нашата икона в хедъра, след като Dawn презапише
        innerHTML-а на #cart-icon-bubble със своята
     5. освежаване на чекмеджето, когато количката се промени от /cart

   Файлът НЕ дефинира custom elements и не пипа cart.js.
   =================================================================== */
(function () {
  'use strict';

  var ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  /* ---------- 3. релсата ------------------------------------------- */

  function railPending() {
    var wraps = document.querySelectorAll('cart-drawer .hrail-wrap');
    for (var i = 0; i < wraps.length; i++) {
      if (!wraps[i].dataset.railReady) return true;
    }
    return false;
  }

  function rescanRail() {
    if (window.NexumRail && typeof window.NexumRail.scan === 'function') {
      window.NexumRail.scan();
    }
  }

  /* ---------- 4. иконата на количката в хедъра ---------------------- */

  var iconHTML = null;

  function cacheIcon() {
    var host = document.getElementById('cart-icon-bubble');
    if (!host) return;
    var mark = host.querySelector('[data-nx-icon]');
    if (mark && !iconHTML) iconHTML = mark.outerHTML;
  }

  function restoreIcon() {
    var host = document.getElementById('cart-icon-bubble');
    if (!host || !iconHTML) return;
    if (host.querySelector('[data-nx-icon]')) return; /* вече е нашата */
    var old = host.querySelector('.svg-wrapper');
    if (old) {
      old.outerHTML = iconHTML;
    } else {
      host.insertAdjacentHTML('afterbegin', iconHTML);
    }
  }

  /* ---------- 1 + 2. добавяне през AJAX ----------------------------- */

  function sectionIds() {
    var d = drawer();
    if (!d || typeof d.getSectionsToRender !== 'function') return [];
    try {
      return d.getSectionsToRender().map(function (s) {
        return s.id;
      });
    } catch (e) {
      return [];
    }
  }

  function addToCart(formData, trigger) {
    var d = drawer();

    if (d) {
      var ids = sectionIds();
      if (ids.length) {
        formData.append('sections', ids.join(','));
        formData.append('sections_url', window.location.pathname);
      }
      if (typeof d.setActiveElement === 'function') {
        d.setActiveElement(trigger || document.activeElement);
      }
    }

    return fetch(ADD_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res && res.status) {
          throw new Error(res.description || res.message || 'Неуспешно добавяне');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: res
          });
        }

        if (d && typeof d.renderContents === 'function' && res.sections) {
          d.classList.remove('is-empty');
          d.renderContents(res);
        } else {
          window.location = CART_URL;
        }
        return res;
      });
  }

  function flashError(message) {
    var box = document.getElementById('CartDrawer-CartErrors');
    if (box) {
      box.textContent = message;
      var d = drawer();
      if (d && typeof d.open === 'function') d.open();
      setTimeout(function () {
        if (box.textContent === message) box.textContent = '';
      }, 6000);
    } else {
      console.error('[nexum-drawer]', message);
    }
  }

  /* карта в решетката: <form action="/cart/add"> извън <product-form> */
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return; /* Dawn го поема */
    if (!drawer()) return; /* без чекмедже — нормалният POST е правилният */

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    addToCart(new FormData(form), btn)
      .catch(function (err) {
        flashError(err.message || 'Продуктът не можа да бъде добавен.');
      })
      .then(function () {
        if (btn) btn.removeAttribute('aria-disabled');
      });
  });

  /* ъпсел бутоните вътре в чекмеджето */
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-nxdr-add]') : null;
    if (add) {
      e.preventDefault();
      if (add.getAttribute('aria-disabled') === 'true') return;
      add.setAttribute('aria-disabled', 'true');

      var fd = new FormData();
      fd.append('id', add.getAttribute('data-nxdr-add'));
      fd.append('quantity', '1');

      addToCart(fd, add).catch(function (err) {
        add.removeAttribute('aria-disabled');
        flashError(err.message || 'Продуктът не можа да бъде добавен.');
      });
    }
  });

  /* ---------- 5. синхрон с /cart ------------------------------------ */

  function refreshDrawer() {
    return fetch(CART_URL + '?section_id=cart-drawer')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var d = drawer();
        if (!d) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) d.classList.toggle('is-empty', fresh.classList.contains('is-empty'));

        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var here = document.querySelector(sel);
          var there = doc.querySelector(sel);
          if (here && there) here.replaceWith(there);
        });
        after();
      })
      .catch(function () {});
  }

  /* ---------- общо след всяка промяна ------------------------------- */

  function after() {
    restoreIcon();
    if (railPending()) rescanRail();
  }

  /* ---------- закачане --------------------------------------------- */

  function boot() {
    cacheIcon();
    after();

    var d = drawer();
    if (d && window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(after, 60);
      }).observe(d, { childList: true, subtree: true });
    }

    var host = document.getElementById('cart-icon-bubble');
    if (host && window.MutationObserver) {
      new MutationObserver(function () {
        restoreIcon();
      }).observe(host, { childList: true });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        after();
        /* Промяна, направена на страницата /cart: cart.js освежава само
           нейните секции, чекмеджето остава старо. Дърпаме го наново, но
           само ако е затворено — иначе бихме прекъснали фокуса. */
        var dd = drawer();
        var onCartPage = !!document.querySelector('cart-items');
        if (event && onCartPage && dd && !dd.classList.contains('active')) {
          refreshDrawer();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.NexumDrawer = {
    open: function () {
      var d = drawer();
      if (d && typeof d.open === 'function') d.open();
    },
    close: function () {
      var d = drawer();
      if (d && typeof d.close === 'function') d.close();
    },
    refresh: refreshDrawer
  };
})();
